import { clsx } from 'clsx';
import type { ComponentProps, ReactNode } from 'react';

export type BadgeVariant = 'event' | 'linked' | 'selected' | 'default';

export interface BadgeProps extends ComponentProps<'span'> {
  /** Visual variant of the badge */
  variant?: BadgeVariant;
  /** Badge content */
  children: ReactNode;
}

const variantStyles: Record<BadgeVariant, string> = {
  event: 'bg-gray-200 text-dorsia-black',
  linked: 'bg-dorsia-green/15 text-dorsia-green-dark',
  selected: 'bg-dorsia-green/15 text-dorsia-green-dark',
  default: 'bg-gray-100 text-dorsia-black',
};

/**
 * Badge - Atom component for small tag/label indicators
 *
 * Used for status labels like EVENT, Linked, Selected.
 * Each variant has distinct background and text colors.
 */
export function Badge({ variant = 'default', children, className, ...props }: BadgeProps) {
  return (
    <span
      className={clsx(
        'font-sailec inline-flex items-center rounded px-2 py-0.5 text-xs font-medium uppercase tracking-wide',
        variantStyles[variant],
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}
